<!--
 * @Author: guang
 * @Date: 2020-12-16 09:44:32
 * @LastEditTime: 2022-11-14 15:17:33
 * @LastEditors: Cherries
 * @Description: APP 引用的隐私政策
-->
<template>
    <div class="page-wrapper ignore">
        <!-- <p class="head" style="text-align:center">隐私政策</p> -->
        <p class="head">
            云印技术（深圳）有限公司严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务。您的隐私对本应用而言至关重要。因此，我们制定了本隐私政策，其中说明了我们如何收集、使用、披露、转让和存储您的信息。请您仔细阅读我们的隐私政策，如有任何问题，请告知我们。
        </p>
        <div class="time">
            最近更新日期：2024年11月05日<br />
            如果您有任何疑惑、意见或建议，请通过以下联系方式与我们联系：4008000873（工作日
            9:00-12:00,14:00-18:00）
        </div>
        <div class="paragraph">
            <h3>1、个人信息的收集和使用</h3>
            <p>
                个人信息是可用于唯一地识别或联系的数据。您在使用本应用时，可能会被要求提供您的个人信息。本应用可查看此个人信息，并按本隐私政策使用该信息。本应用还可将此信息与其他信息合并在一起，用于提供和改进我们的产品、服务、内容和广告宣传。
            </p>
            <div class="table">
                <div class="title">
                    <div>业务场景</div>
                    <div>收集目的</div>
                    <div>收集的方式</div>
                    <div>个人信息字段</div>
                </div>
                <div
                    v-for="(item, index) in personalList"
                    :key="index"
                    class="content"
                >
                    <div>{{ item.scene }}</div>
                    <div>{{ item.objective }}</div>
                    <div>{{ item.mode }}</div>
                    <div>{{ item.info }}</div>
                </div>
            </div>
        </div>
        <p>
            下文是本应用可能收集的个人信息的类型以及我们如何使用该信息的一些示例。
        </p>
        <div class="paragraph">
            <h3>2、我们收集何种个人信息</h3>
            <p>
                当您使用本应用时，我们会收集各种信息，包括您的姓名、联系方式、公司信息、邮寄地址等。
            </p>
        </div>
        <div class="paragraph">
            <h3>3、我们如何使用您的个人信息</h3>
            <p>
                我们收集的个人信息让我们可以将最新产品发布、软件更新及活动预告及时通知您。这些信息还有助于我们改进我们的服务、内容和广告宣传。如果您不希望被列入我们的发送名单中，您可在任何时候通过更新您的设置选择退出。
            </p>
        </div>
        <div class="paragraph">
            <p>
                我们还使用个人信息以帮助我们开发、交付和改进我们的产品、服务、内容和广告宣传。我们会不时地使用您的个人信息以发送重要通知，如关于购买以及我们的条款、条件和政策变更的通讯。由于此信息对您与本应用之间的互动至关重要，您不能放弃接收此类沟通信息。
            </p>
        </div>
        <div class="paragraph">
            <h3>4、收集和使用非个人信息</h3>
            <p>
                我们也会收集非个人信息——即不会与任何特定个人直接相关联的数据。我们可出于任何目的而收集、使用、转让和披露非个人信息。下文是我们可能收集的非个人信息以及我们如何使用该信息的一些示例。
            </p>
        </div>
        <div class="paragraph">
            <p>
                我们会收集诸如职业、语言、邮编、区号、设备唯一识别码、位置以及使用本应用产品所在的地区等信息，以便我们能更好地了解客户的行为，改进我们的产品、服务和广告宣传。我们还会收集与客户在我们网站的信息，以及从我们其他产品和服务获得的信息。我们会将此类信息汇总用于帮助我们向客户提供更有用的信息，并了解客户对我们网站、产品和服务中的哪些部分最感兴趣。就本隐私政策而言，汇总数据被视为非个人信息。
            </p>
        </div>
        <!-- <div class="paragraph">
            <p>
                （1）我们的推送服务由第三方合作伙伴【极光】提供，在提供该等服务的过程中，第三方合作伙伴需要收集您的相关个人信息，包括设备信息[
                设备信息包括：设备标识符（IMEI、IDFA、Android
                ID、MAC、OAID、IMSI等相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）]、网络信息[
                网络信息包括：IP地址，WiFi信息，基站信息等相关信息。
                ]、地理位置信息。为向您提供更好的服务、改善技术和提升用户体验，您理解并同意，我们有权在必要范围内向第三方合作伙伴提供您的个人信息，且第三方合作伙伴亦可以基于前述目的自行收集和使用您的个人信息，并在保护您个人信息和隐私权以及符合适用法律法规的前提下，将收集的信息和数据经去标识化或匿名化处理后用于其他服务和用途。当我们要将个人信息用于本政策未载明的其它用途时，会事先通知您并征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，也会事先通知您并并征求您的同意。
            </p>
            <p>
                （2）我们的定位服务由第三方合作伙伴【百度地图】提供，当用户使用百度地图定位服务时，百度地图会收集Wi-Fi状态信息和定位信息，以便给开发者返回最终用户的位置信息，供开发者基于最终用户的位置信息向最终用户提供相应服务
            </p>
            <p>
                （3）我们的统计服务由第三方合作伙伴【友盟统计】提供，【友盟+】统计分析服务帮助我们了解我们的最终用户如何使用我们的产品（含服务，包括但不限于移动应用客户端、移动网站、应用平台、PC网站、站点及【友盟+】确认可提供服务的其他终端等，以下同），并且帮助我们分析您的产品在不同终端设备上的表现。友盟统计收集唯一设备识别码（IMEI/Mac/android
                ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
                信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。
            </p>
            <p>
                除上述个人信息外，统计分析服务将根据统计维度的不同采集如下信息：SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等
            </p>
            <p>
                （4）我们的错误日志收集服务由第三方合作伙伴【bugly】提供，为实现各类
                Bugly SDK 的特定业务功能，Bugly 可能需要向 App
                开发者和/或终端用户收集相关个人信息，主要包括：日志信息（包括：第三方开发者自定义日志、Logcat
                日志以及 APP 崩溃堆栈信息）、设备 ID（包括：androidid
                以及idfv）、联网信息、系统名称、系统版本以及国家码。
            </p>
            <p>
                （5）相机拍照功能为我们的拍照下单和唛头校对功能，我们需要向用户申请相机权限，以拍照获取的图片进行下单或唛头文件校对。
            </p>
        </div> -->
        <div class="table table2">
            <div class="title">
                <div>第三方名称</div>
                <div>使用目的</div>
                <div>功能类型</div>
                <div>
                    <div>涉及个人信息</div>
                    <div class="sub-header">
                        <div>字段名称</div>
                        <div>字段用途</div>
                    </div>
                </div>
                <div>第三方官网链接</div>
            </div>
            <div
                v-for="(item, index) in thirdList"
                :key="index"
                class="content"
            >
                <div style="display: flex;justify-content: center;align-items: center;">{{ item.name }}</div>
                <div style="display: flex;justify-content: center;align-items: center;">{{ item.objective }}</div>
                <div style="display: flex;justify-content: center;align-items: center;">{{ item.type }}</div>
                <div class="info-cell set-int-fsdfdddd">
                    <div
                        v-for="(key, value) in item.info"
                        :key="key"
                        class="info-row"
                    >
                        <div>{{ value }}</div>
                        <div>{{ key }}</div>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;">
                    <span style="color: #145dff" @click="goGw(item.url)">{{
                        item.url
                    }}</span>
                </div>
            </div>
        </div>
        <p>
            如果我们将非个人信息与个人信息合并在一起，在保持合并的期间内，此类信息将被视为个人信息。
        </p>
        <div class="paragraph">
            <h3>5、向第三方披露</h3>
            <p>
                有时本应用会向与本应用合作提供产品和服务或者帮助本应用向客户进行营销的战略合作伙伴提供某些个人信息。例如，当您购买纸板下单时，您即授权本应用及其运营商交流您在购买过程中提供的信息，以便我们提供服务。如果您获准使用服务，您的帐号将适用本应用及其运营商各自的隐私政策。本应用只会为提供或改进我们的产品、服务和广告宣传之目的而与第三方共享个人信息；而不会为第三方的营销目的与第三方共享个人信息。
            </p>
        </div>
        <div class="paragraph">
            <h3>6、服务提供商</h3>
            <p>
                本应用与提供信息处理、履行客户订单、向您交付产品、管理和增强客户数据、提供客户服务、评估您对我们产品和服务的兴趣以及开展客户调查或满意度调查的公司分享个人信息。这些公司有义务保护您的信息，并可能位于本应用从事经营活动所在的任何地点。
            </p>
        </div>
        <div class="paragraph">
            <h3>7、其他</h3>
            <p>
                根据法律、法律程序、诉讼和/或公共机构和政府部门的要求，本应用可能有必要披露您的个人信息。如果我们认为就国家安全、执法或具有公众重要性的其他事宜而言，披露是必须的或适当的，则我们可披露与您的有关信息。
            </p>
        </div>
        <div class="paragraph">
            <p>
                如果我们确定为了执行我们的条款和条件或保护我们的经营或用户，披露是合理必须的，则我们可披露与您有关的信息。此外，如果发生重组、合并或出售，则我们可将我们收集的一切个人信息转让给相关第三方。
            </p>
        </div>
        <div class="paragraph">
            <h3>8、个人信息的保护</h3>
            <p>
                本应用采取各种预防措施，包括行政、技术和实际的措施，以保障您的个人信息免遭丢失、盗用和误用，以及被擅自取阅、披露、更改或销毁。
            </p>
        </div>
        <div class="paragraph">
            <h3>9、个人信息的完整性和保留</h3>
            <p>
                本应用将使您能够方便地确保您的个人信息是准确、完整和最新的。我们将在实现本隐私政策中所述目的所必需的期间内保留您的个人信息，除非法律要求或允许在更长的期间内保留该等信息。
            </p>
        </div>
        <div class="paragraph">
            <h3>10、第三方网站和服务</h3>
            <p>
                本应用的网站、产品、应用软件和服务中可能含有第三方网站、产品和服务的链接。我们的产品和服务也可能使用或提供来自第三方的产品或服务。第三方收集的、其中可能含有位置数据或联系方式等的信息，受第三方隐私惯例的管辖。我们希望您能了解这些第三方的隐私惯例。
            </p>
        </div>
        <div class="paragraph">
            <h3>11、全公司对您隐私的承诺</h3>
            <p>
                为确保您的个人信息的安全，我们将公司的隐私和安全准则告知全体云印员工，并将在公司内部严格执行隐私保护措施。
            </p>
        </div>
        <div class="paragraph">
            <h3>12、隐私问题</h3>
            <p>
                如果您对本应用的隐私政策或数据处理有任何问题或顾虑，请联系我们。
            </p>
        </div>
        <div class="paragraph">
            <h3>13、注销账号</h3>
            <p>
                你可以在箱易通“设置-注销账号”中申请账号注销。在你注册账号前，我们将验证你的个人身份、安全状态、支付财产、权限信息等。我们将会在收到你的申请后及时进行处理，并在十五个工作日或法律法规要求的时限内回复你的请求。你知悉并理解，注销账号的行为是不可逆的行为，当你注销账号后，我们将删除有关你的相关信息或进行匿名化处理，但法律法规及相关国家标准另有规定的除外。
            </p>
            <p>有关注销的流程和内容，请参见《注销须知》。</p>
        </div>
        <div class="paragraph">
            <p>
                本应用可随时对其隐私政策加以更新。如果我们对隐私政策作出重大变更，我们将在云印技术（深圳）有限公司官网上刊登通告和经更新的隐私政策。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "userPrivacy",
    data() {
        return {
            personalList: [
                {
                    scene: "注册、登录",
                    objective:
                        "用于注册、创建账号、完善账号信息。（QQ号码）由于关联创建腾讯企点账号",
                    mode: "用户输入",
                    info: "姓名、身份张号码、公司信息、手机号码、QQ号码"
                },
                {
                    scene: "下单",
                    objective: "用于下单后物流配送",
                    mode: "用户输入",
                    info: "地址信息"
                },
                {
                    scene: "首页抢购活动区域展示",
                    objective: "用于分区域显示不同的抢购活动",
                    mode: "APP收集",
                    info: "位置信息"
                },
                {
                    scene: "拍照下单",
                    objective: "用于用户拍照下单功能",
                    mode: "用户拍照上传",
                    info: "用户照片"
                },
                {
                    scene: "唛头校对",
                    objective: "唛头文件校对",
                    mode: "用户拍照上传",
                    info: "用户照片"
                }
            ],
            thirdList: [
                {
                    name: "高德地图",
                    objective: "为首页抢购活动提供区域活动位置依据",
                    type: "定位SDK",
                    info: {
                        IDFA: "追踪、排查、诊断、统计服务中的各类问题",
                        OAID: "追踪、排查、诊断、统计服务中的各类问题",
                        GAID: "追踪、排查、诊断、统计服务中的各类问题",
                        应用名:
                            "服务鉴权，追踪、排查、诊断、统计服务中的各类问题",
                        应用版本号:
                            "服务鉴权，追踪、排查、诊断、统计服务中的各类问题",
                        设备品牌及型号:
                            "追踪、排查、诊断、统计服务中的各类问题",
                        操作系统: "追踪、排查、诊断、统计服务中的各类问题",
                        运营商信息: "协助提升网络定位精度",
                        屏幕分辨率: "追踪、排查、诊断、统计服务中的各类问题",
                        IP地址: "提供网络定位",
                        GNSS信息: "获取卫星状态，优化及判断卫星定位效果",
                        网络类型: "用于识别当前网络状态（4G/5G或WiFi）",
                        WiFi状态: "用于识别网络状态及信息进行辅助定位",
                        WiFi参数: "用于识别网络状态及信息进行辅助定位",
                        WiFi列表: "用于识别网络状态及信息进行辅助定位",
                        WiFi信号强度的信息:
                            "用于识别网络状态及信息进行辅助定位",
                        WiFi网关地址: "用于识别网络状态及信息进行辅助定位",
                        SSID: "用于识别移动热点，优化定位效果",
                        BSSID: "用于服务端进行网络WiFi定位",
                        基站信息: "用于服务端进行网络基站定位",
                        传感器信息: "用于进行辅助定位",
                        设备信号强度信息: "协助提升网络定位精度",
                        经纬度: "向用户提供精确的位置信息"
                    },
                    url: "https://lbs.amap.com/pages/privacy/"
                },
                {
                    name: "阿里热修复shopx",
                    objective: "用于紧急修复APP线上问题",
                    type: "热修复SDK",
                    info: {
                        "设备信息（包括操作系统、设备型号），运营商信息，网络信息，应用列表":
                            "用于按标签下发补丁"
                    },
                    url:
                        "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.5fea674bPIUMcE"
                },
                {
                    name: "腾讯Bugly",
                    objective:
                        "为我们收集应用在用户使用过程中错误日志和崩溃信息",
                    type: "错误日志收集SDK",
                    info: {
                        手机型号:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机型号有关",
                        手机品牌:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机品牌有关",
                        Android系统版本:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与Android系统版本有关",
                        Android系统api等级:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与Android系统api有关",
                        厂商系统版本:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与厂商系统版本有关",
                        cpu架构类型:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与CPU架构有关",
                        设备是否root:
                            "在APP发生闪退时，识别Crash等问题是否是由于root导致",
                        磁盘空间占用大小:
                            "在APP发生闪退时，识别Crash等问题是否是由于磁盘剩余空间小导致",
                        sdcard空间占用大小:
                            "在APP发生闪退时，识别Crash等问题是否是由于sdcard剩余空间小导致",
                        内存空间占用大小:
                            "在APP发生闪退时，识别Crash等问题是否是由于内存空间小导致",
                        网络类型:
                            "在APP发生闪退时，识别Crash等问题是否与网络类型有关",
                        应用当前正在运行的进程名和PID:
                            "在APP发生闪退时，判断当前进程的ANR状态，排查崩溃问题, 帮助APP提升稳定性",
                        Android_ID:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与特定用户行为有关",
                        设备序列号:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与特定用户行为有关",
                        ICCID:
                            "排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与特定用户行为有关"
                    },
                    url:
                        "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                },
                {
                    name: "极光推送",
                    objective:
                        "为用户提供抢购活动、报价单发布、材质发布、订单发货、配送的消息推送",
                    type: "推送SDK",
                    info: {
                        "设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID）":
                            "用于生成脱敏的终端用户设备唯一性标识，以确保能准确进行消息推送。",
                        "设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）":
                            "用于保证服务在不同设备上的兼容性，确保消息准确下发。",
                        "操作系统信息（包括操作系统版本、系统名称、系统语言）":
                            "用于保证服务在不同设备上的兼容性，确保消息准确下发。",
                        "网络信息（包括网络类型、运营商信息、IP地址、WIFI状态信息）":
                            "用于判断SDK与服务器的网络连接状态，保证服务的稳定性和连续性。",
                        推送信息日志:
                            "用于您查询推送服务记录，了解推送信息送达的情况。",
                        "设备标识符（包括IMEI、MAC、IMSI）":
                            "用于对生成终端用户设备唯一标识的补充，提升唯一设备标识的准确性，进而提升推送的精确度和触达率。",
                        "网络信息（包括SSID、BSSID、WiFi列表信息、基站信息）":
                            "用于判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。",
                        "软件列表信息（包括软件列表及软件运行列表信息）、位置相关信息":
                            "有助于帮助您洞察您终端用户的兴趣偏好，实现用户分群推送；通过该功能为用户提供更合适的推送内容，尽量减少无用推送内容对用户的打扰，进一步提升用户体验。",
                        位置相关信息:
                            "用于提供‘推送报表’以及地理围栏推送功能。",
                        "软件列表信息（包括软件列表及软件运行列表信息）、位置相关信息_1":
                            "我们采用合并链路技术进行信息推送，当一个设备有多个APP的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户省电省流量的目的，当一个设备有离线推送消息待下发的场景时，通过关联启动功能可以下发离线消息，当您关闭这项服务时，关联启动也同时会关闭，会导致电量和流量消耗加大，同时消息触达率也会降低。",
                        "软件列表信息（包括软件列表及软件运行列表信息）、位置相关信息_2":
                            "主要用于优化SDK长连接，提升推送送达率及应用活跃度，开发者可以按需配置。",
                        应用收到推送后切换到后台和前台的活跃时长数据:
                            "为了帮助开发者更好的分析推送效果和用户行为，进一步优化您的推送策略，提高用户参与度和转化率。"
                    },
                    url: "https://www.jiguang.cn/license/privacy"
                },
                {
                    name: "友盟统计",
                    objective:
                        "帮助我们了解用户的使用习惯及常用功能，以便于为用户提供更好的使用体验",
                    type: "统计SDK",
                    info: {
                        "设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息":
                            "进行APP运营统计与分析"
                    },
                    url: "https://www.umeng.com/page/policy"
                },
                {
                    name: "七牛云",
                    objective: "用户注册、完善个人信息上传图片",
                    type: "云服务SDK",
                    info: {
                        设备厂商:
                            "用于判断用户的手机类型，以备兼容性及问题排查",
                        设备机型:
                            "用于判断用户的手机类型，以备兼容性及问题排查",
                        设备系统信息:
                            "用于判断用户的手机类型，以备兼容性及问题排查",
                        IP地址: "用于上传优化路由，提升用户体验"
                    },
                    url:
                        "https://developer.qiniu.io/kodo/11868/the-sdk-privacy-policy"
                },
                {
                    name: "QQ",
                    objective: "分享产品或活动信息到QQ好友或空间",
                    type: "分享产品、活动",
                    info: {
                        设备型号信息: "快速定位解决机型兼容性问题",
                        剪切板信息: "实现第三方App分享能力",
                        内存卡权限:
                            "实现终端用户使用本地图片分享至QQ、QQ空间或进行头像设置",
                        "特定应用（QQ、TIM）的安装情况":
                            "适用于Android版本，App终端用户使用分享到QQ/TIM、加好友等功能"
                    },
                    url:
                        "https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
                },
                {
                    name: "微信支付",
                    objective: "实现微信支付",
                    type: "第三方支付",
                    info: {
                        验证用户设备上安装微信APP的状态:
                            "用于确认该设备是否能够实现Open SDK的相关能力，如设备上未安装微信APP，用户将无法使用微信Open SDK能力所实现的相关功能",
                        收集用户发起支付时第三方应用生成的微信支付订单标识并向微信APP传输:
                            "为实现让用户在第三方应用中使用微信支付功能"
                    },
                    url:
                        "https://posts.tenpay.com/posts/18ed0968618e3db204d4931651708953.html"
                },
                {
                    name: "支付宝（中国）网络技术有限公司",
                    objective: "实现应用内支付宝支付",
                    type: "App 支付宝客户端 SDK",
                    info: {
                        "Android ID、OAID、AAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表":
                            "  1. 保障用户账户和资金安全以及支付服务的安全稳定运行。2. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。3. 实现网络链路的选择和优化，以提升用户体验。"
                    },
                    url:
                        "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132"
                },
                {
                    name: "支付宝（中国）网络技术有限公司",
                    objective: "简单快捷地获取设备 ID",
                    type: "设备标识SDK",
                    info: {
                        "设备信息，设备信息（包括IMEI、AndroidID、操作系统、设备型号）":
                            "应用程序安全有效地找到特定设备"
                    },
                    url:
                        "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.3291682fyRebYy"
                }
            ]
        };
    },
    created() {
        let title = window.location.hostname.includes("zhiban")
            ? "纸板微供"
            : "春辉";
        document.title = `${title}用户服务协议`;
    },
    methods: {
        goGw(url) {
            window.location.href = url;
        }
    }
};
</script>

<style lang="less" scoped>
.head {
    // text-indent: 36px;
    font-weight: 700;
    text-align: center;
    font-family: PingFang-SC-Regular;
}

.ignore.page-wrapper {
    font-family: PingFang-SC-Regular;
    overflow: auto;
    font-size: 14px;
    padding: 20px;
    line-height: 1.6em;
    text-align: justify;
    h3 {
        font-size: 14px;
        font-weight: 700;
    }
}
.paragraph {
    margin-bottom: 1em;
}
.table {
    margin: 5px 0;
    > div {
        display: flex;
        > div {
            padding: 3px;
            width: 25%;
            text-align: center;
            border-top: 1px solid #e5e5e5;
            border-right: 1px solid #e5e5e5;
            word-break: break-all;
            vertical-align: middle;
        }
        > div:first-child {
            border-left: 1px solid #e5e5e5;
        }
    }
    > div:last-child {
        border-bottom: 1px solid #e5e5e5;
    }
}
.sub-header {
    display: flex;

    > div {
        flex: 1;
        padding: 3px;
        margin-top: 4px;
        border-top: 1px solid #e5e5e5;
        &:first-child {
            border-right: 1px solid #e5e5e5;
        }
    }
}
.info-cell {
    .info-row {
        display: flex;

        > div {
            flex: 1;
            padding: 3px;

            &:first-child {
                border-right: 1px solid #e5e5e5;
            }
        }

        &:not(:last-child) {
            border-bottom: 1px solid #e5e5e5;
        }
    }
}
.table2 {
    > div {
        > div {
            width: 20%;
        }
    }
}
.time {
    margin: 5px 0;
}
</style>
